
export const USER_STATE = {
  activated: 1,
  adminVerified: 2,
  deleted: 4,
  emailVerified: 8,
  invited: 16,
};

/**
 *  Invitation time to live (TTL) in seconds
 *  @type {Number}
 */
export const INVITE_TTL = 2 * 60 * 60;

